export function debounce(func, timeout) {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            clearTimeout(timeoutId);
            func(...args);
        }, timeout);
    };
}
